import { Component, inject } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { MenuItem } from '../types';
import { UserService } from '../services/user.service';
import { ThemeService } from '../services/theme.service';
import { AuthenticationService } from '../authentication/authentication.service';

@Component({
  selector: 'app-topbar',
  imports: [RouterLink, RouterLinkActive, NzIconModule, NzButtonModule, NzDropdownModule, NzMenuModule, UpperCasePipe],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss',
})
export class Topbar {
  userService = inject(UserService);
  themeService = inject(ThemeService);
  authService = inject(AuthenticationService);

  menuItems: MenuItem[] = [
    { label: 'Dashboard', route: '/dashboard', exact: false },
    { label: 'Contacts', route: '/contacts', exact: false },
    { label: 'Lists', route: '/lists', exact: false },
    { label: 'Campaigns', route: '/campaigns', exact: false },
    { label: 'Templates', route: '/templates', exact: false },
    { label: 'Enrichment', route: '/enrichment', exact: false },
  ];

  toggleTheme(): void {
    this.themeService.toggle();
  }

  refresh(): void {
    window.location.reload();
  }

  logout = () => {
    this.authService.logout();
  };
}
